import { api } from "@shared/lib/api";
import { BackednResponse } from "@shared/lib/types";
import {
  ICreatePermissionGroup,
  IEditPermissionGroup,
  IGetPermissionGroups,
} from "@shared/lib/types/permissions";

export class PermissionGroupsService {
  public static async getPermissionGroups(searchQuery?: string) {
    const response = (await api
      .post("permissions/groups/search", {
        json: {
          query: searchQuery,
        },
      })
      .json()) as BackednResponse<IGetPermissionGroups>;
    return response;
  }

  public static async createPermissionGroup(
    permissionGroup: ICreatePermissionGroup
  ) {
    const response = (await api
      .put("permissions/groups", {
        json: permissionGroup,
      })
      .json()) as BackednResponse<void>;
    return response;
  }

  public static async editPermissionGroup(
    permissionGroup: IEditPermissionGroup
  ) {
    const response = (await api
      .post("permissions/groups", {
        json: { ...permissionGroup, permissionGroupId: permissionGroup._id },
      })
      .json()) as BackednResponse<void>;
    return response;
  }

  public static async deletePermissionGroup(permissionGroupId: string) {
    const response = (await api
      .delete(`permissions/groups/`, {
        json: { permissionGroupId },
      })
      .json()) as BackednResponse<void>;
    return response;
  }
}
